import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getCaptcha = () => axios.get(`${API}/captcha`);
export const createLead = (payload) => axios.post(`${API}/leads`, payload);
export const fetchLeads = (key) =>
  axios.get(`${API}/leads`, { headers: { "x-admin-key": key } });
